import React from "react";

const AboutCard = ({ item, local }) => {
  return (
    <div
      style={{ background: `${local === "dark" ? "transparent" : item?.bg}` }}
      className="about-box dark:bg-transparent"
    >
      <div className="grid grid-cols-3 gap-2">
        <div className="col-span-1 flex items-center justify-center">
          <img
            className="object-contain block"
            src={item?.icon}
            alt=""
          />
        </div>
        <div className="col-span-2 flex items-center justify-center">
          <div className="text-center">
            <h3 className="dark:text-white text-2xl font-semibold">
              {item?.title}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AboutCard;
